"use strict";

const RoutineInspectionRouteFactory = require("./routineInspectionRouteFactory");

const CleanoutRoutes = function () {
  const inspectionRoute = RoutineInspectionRouteFactory.createRoute({
    resourceKey: "cleanoutRoutineMaintenance",
    assetType: "cleanout",
  });

  return { inspectionRoute };
};

module.exports = CleanoutRoutes();
